import classNames from "classnames";
import Button from "../Button/Button";
import styles from "./ConfirmationModal.module.css";

function ConfirmationModal({
  className,
  onClose,
  onSubmit,
  loading,
  destructive,
  confirmationText = "Confirm",
  confirmDisabled,
  cancelText = "Cancel",
  children,
  type = "button",
  sticky,
}: {
  className?: string;
  onClose?: () => void;
  onSubmit?: () => void | Promise<void>;
  loading?: boolean;
  destructive?: boolean;
  confirmationText?: string;
  confirmDisabled?: boolean;
  cancelText?: string;
  children?: React.ReactNode;
  type?: "submit" | "button";
  sticky?: boolean;
}) {
  return (
    <>
      {children}
      <div
        className={classNames(styles.buttonGroup, className, {
          [styles.sticky]: sticky,
        })}
      >
        {onClose && (
          <Button
            variant="outline"
            size="small"
            onClick={onClose}
            type={type}
            disabled={loading}
          >
            {cancelText}
          </Button>
        )}
        <Button
          variant="primary"
          size="small"
          destructive={destructive}
          disabled={confirmDisabled || loading}
          loading={loading}
          type={!onSubmit ? "submit" : undefined}
          onClick={onSubmit ?? undefined}
        >
          {confirmationText}
        </Button>
      </div>
    </>
  );
}

export default ConfirmationModal;
